module.exports = __webpack_public_path__ + "static/media/BeatrizMoreira.088be82a.png";